(() => {
  const containerSelector = '.product__media_container';
  const resultSelector = '.pdp-zoom-result';

  function getActiveImg(container) {
    return container.querySelector('.product__media-item.is-active img') ||
           container.querySelector('.product__media img');
  }

  function startZoom(container, result, img) {
    const src = img.currentSrc || img.src;
    if (!src) return;

    container.classList.add('is-zooming');
    result.style.backgroundImage = `url("${src}")`;
    result.style.backgroundRepeat = 'no-repeat';
    result.style.backgroundSize = '200% 200%';
  }

  function moveZoom(e, container, result, img) {
    const rect = img.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width;
    const y = (e.clientY - rect.top) / rect.height;

    // Clamp 0..1
    const cx = Math.max(0, Math.min(1, x));
    const cy = Math.max(0, Math.min(1, y));

    result.style.backgroundPosition = `${cx * 100}% ${cy * 100}%`;
  }

  function stopZoom(container, result) {
    container.classList.remove('is-zooming');
    result.style.backgroundImage = '';
  }

  function bind(container) {
    const result = container.querySelector(resultSelector);
    if (!result) return;

    container.addEventListener('mouseenter', (e) => {
      const img = getActiveImg(container);
      if (!img) return;
      startZoom(container, result, img);
    });

    container.addEventListener('mousemove', (e) => {
      if (!container.classList.contains('is-zooming')) return;
      const img = getActiveImg(container);
      if (!img) return;
      moveZoom(e, container, result, img);
    });

    container.addEventListener('mouseleave', () => stopZoom(container, result));
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(containerSelector).forEach(bind);
  });
})();